export function Spinner({ size = 24 }: { size?: number }) {
  return (
    <span
      className="inline-block border-2 border-[var(--color-text-secondary)] border-t-transparent rounded-full animate-spin"
      style={{ width: size, height: size }}
      role="status"
      aria-label="Loading"
    />
  );
}
